export default "__VITE_ASSET__DifEVIr1__"